import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

class ScrollCards {
  private wrapper: HTMLElement;
  private cardWrappers: NodeListOf<HTMLElement>;
  private cards: NodeListOf<HTMLElement>;

  constructor(wrapper: HTMLElement) {
    this.wrapper = wrapper;
    this.cardWrappers = wrapper.querySelectorAll("[data-card-wrapper]");
    this.cards = wrapper.querySelectorAll("[data-card]");

    if (this.cards.length > 0 && window.innerWidth >= 1024) {
      this.init();
    }
  }

  private init(): void {
    this.setupScrollAnimation();
    this.handleResize();
  }

  private setupScrollAnimation(): void {
    if (this.cardWrappers.length === 0 || this.cards.length === 0) return;

    // Kill any existing ScrollTriggers
    ScrollTrigger.getAll().forEach((trigger) => {
      if (trigger.vars.id && trigger.vars.id.toString().includes("card-")) {
        trigger.kill();
      }
    });

    const container = this.wrapper.querySelector(".scroll-cards-container");
    if (!container) return;

    // Animate each card
    this.cardWrappers.forEach((wrapper, i) => {
      const card = this.cards[i];
      const cardInner = card.querySelector(".container > div") as HTMLElement;

      if (!cardInner) {
        console.warn(`Card inner not found for card ${i}`);
        return;
      }

      // All cards scale to the same size
      let targetScale = 0.85; // Same scale for all cards
      let targetRotationX = -10;

      // Set initial state - full size
      gsap.set(cardInner, {
        scale: 1,
        rotationX: 0,
        transformOrigin: "top center",
      });

      // Create ScrollTrigger for all cards
      gsap.to(cardInner, {
        scale: targetScale,
        rotationX: targetRotationX,
        transformOrigin: "top center",
        ease: "power2.out",
        scrollTrigger: {
          trigger: wrapper,
          start: `top ${60 + 10 * i}`,
          end: "bottom 550",
          endTrigger: "[data-scroll-cards]",
          scrub: 1,
          pin: wrapper,
          pinSpacing: i === this.cardWrappers.length - 1 ? true : false,
          id: `card-${i}`,
          markers: false,
        },
      });
    });
  }

  private handleResize(): void {
    let resizeTimer: number;

    window.addEventListener("resize", () => {
      clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(() => {
        if (window.innerWidth >= 1024) {
          this.setupScrollAnimation();
        } else {
          ScrollTrigger.getAll().forEach((trigger) => trigger.kill());
          this.cards.forEach((card) => {
            const cardInner = card.querySelector(
              ".container > div",
            ) as HTMLElement;
            if (cardInner) {
              gsap.set(cardInner, {
                scale: 1,
                rotationX: 0,
                clearProps: "transform",
              });
            }
          });
        }
      }, 250);
    });
  }

  public destroy(): void {
    ScrollTrigger.getAll().forEach((trigger) => trigger.kill());
  }
}

document.addEventListener("DOMContentLoaded", () => {
  const scrollCardsWrappers = document.querySelectorAll<HTMLElement>(
    "[data-scroll-cards]",
  );

  scrollCardsWrappers.forEach((wrapper) => {
    new ScrollCards(wrapper);
  });
});

if (window.wp?.domReady) {
  window.wp.domReady(() => {
    const scrollCardsWrappers = document.querySelectorAll<HTMLElement>(
      "[data-scroll-cards]",
    );

    scrollCardsWrappers.forEach((wrapper) => {
      new ScrollCards(wrapper);
    });
  });
}
